import { render } from "./Video.vue?vue&type=template&id=17157235&scoped=true&ts=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=17157235&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17157235"]])

export default __exports__